var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 107,
    viewBox: "0 0 153 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.629 1.15C15.763 2.147 10.726 3.871 6.505 9.405C2.167 15.093 0.938 22.252 0.312 45.5C-0.507 75.876 1.595 91.66 7.284 97.857C11.514 102.466 16.463 103.803 33.483 104.936C68.053 107.237 129.69 105.709 138.105 102.341C143.024 100.373 147.606 95.177 149.006 89.979C153.06 74.923 153.042 31.011 148.976 15.909C147.604 10.814 142.988 5.612 138.105 3.659C135.76 2.72 127.989 1.694 118.384 1.055C100.053 -0.164999 49.427 -0.11 30.629 1.15ZM80.959 39.129C93.71 45.8 103.773 51.601 103.321 52.02C102.271 52.995 58.925 75.392 57.253 75.823C56.274 76.076 56 70.772 56 51.573C56 37.916 56.395 27 56.888 27C57.377 27 68.209 32.458 80.959 39.129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.16cd0f62942023f753376ef24c70b441.svg";
export { ForwardRef as ReactComponent };